import { z } from 'zod';

export const bdm2OutcomeStudyIdSchema = z.string().min(1).max(32);
export const bdm2OutcomeDrawnProductSchema = z.string().min(1).max(255);

// ETH ships the survey round as "1" or "2"
const surveyRoundByValue: Record<'1' | '2', 1 | 2> = { '1': 1, '2': 2 };
export const bdm2OutcomeDrawnSurveyRoundSchema = z
  .enum(['1', '2'])
  .transform((value) => surveyRoundByValue[value]);

const nonNegativeIntegerSchema = z
  .string()
  .regex(/^\d+$/)
  .transform((value) => Number(value))
  .refine((value) => value <= 1000, {
    message: 'must be at most 1000',
  });

export const bdm2OutcomeMaxPriceOfDrawnProductSchema = nonNegativeIntegerSchema;
export const bdm2OutcomeDrawnPriceSchema = nonNegativeIntegerSchema;
export const bdm2OutcomeGalaxusValueSchema = nonNegativeIntegerSchema.refine(
  (value) => value % 5 === 0,
  { message: 'galaxus_value must be a multiple of 5' },
);
export const bdm2OutcomeCashMoneySchema = nonNegativeIntegerSchema;

// ETH's own "final implementation" column, e.g. "Blüten 12 Percent" or "no product".
// Not stored: it is fully derivable, but cross-checking it against that derived
// value catches a row where ETH's own file disagrees with itself.
export const bdm2OutcomeProductFinalSchema = z.string().min(1);

export const bdm2OutcomesImportRow = z.array(z.string());
